import Header from "../components/header";
import Footer from "../components/footer";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";


export default function Layout() {
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    // Check if the route is "/contact"
    if (location.pathname === "/contact-us") {
      return; // Do not redirect if the route is "/contact"
    }

    // Check for the authorization cookie
    const authToken = window.localStorage.getItem("authToken")
    if (!authToken) {
      // Redirect to the login page if the token is missing
      navigate("/login");
    }
  }, [location.pathname, navigate]);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">


      < Header />
      <Outlet />

      <Footer />
    </div >
  );
}